import { useState, useEffect, useCallback } from 'react';
import { fetchWithCache } from '../utils/cacheUtils';
import useApi from './useApi';

export const useDocumentApi = () => {
    const api = useApi();
    const [documentTypes, setDocumentTypes] = useState([]);

    const getDocumentTypes = useCallback(() => {
        return api.get('/api/v1/document/types');
    }, [api]);

    useEffect(() => {
        const fetchTypes = async () => {
            try {
                const data = await fetchWithCache(getDocumentTypes, 'documentTypes');
                setDocumentTypes(data);
            } catch (error) {
                // Error is already handled by the interceptor in useApi
                console.error('Failed to fetch document types (hook):', error);
            }
        };

        fetchTypes();
    }, [getDocumentTypes]);

    const addDocument = useCallback(async (documentData) => {
        // Assuming the endpoint is /api/v1/documents
        return api.post('/api/v1/documents', documentData);
    }, [api]);

    const uploadDocument = useCallback(async (documentId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        // Assuming the endpoint for upload and that it expects multipart/form-data
        return api.post(`/api/v1/documents/${documentId}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }, [api]);

    return { documentTypes, addDocument, uploadDocument };
};
